export default {
    CRYPTO: {
        id: 'crypto',
        projectId: "ok-ui",
        variant: "es",
        path: "/myprofile/broker/crypto",
        customUrl: 'ok-ui-crypto'
    },
    TRANSFERS: {
        id: 'transfers',
        projectId: "ok-ui",
        variant: "es",
        path: "/myprofile/transfers",
        customUrl: 'ok-ui-transfers'
    }
};